import { getUtClientId } from 'libs/cookie';

async function getGaClientId(): Promise<string> {
  return new Promise((resolve) => window.ga(() => resolve(window.ga.getAll()[0].get('clientId'))));
}

async function delay(timeout: number): Promise<undefined> {
  return new Promise((resolve) => setTimeout(resolve, timeout));
}

export async function getClientId() {
  if (typeof window === 'undefined') {
    return;
  }
  let clientId;
  try {
    clientId = await Promise.race([getGaClientId(), delay(500)]);
  } catch (e) {
  } finally {
    return clientId || getUtClientId();
  }
}
